import React, { FC } from 'react'

import clsx from 'clsx'

import { getRankClasses, toFixed } from '../../../../../helpers/helpers'

import { IRegistrationByDayInterface } from '../../../../../models/registrations-by-day/registrationByDay.interface'

interface ScoringModalTotalPointsProps {
  row: IRegistrationByDayInterface
  results: IRegistrationByDayInterface['score']
  totalPoints: number
  maxPoints: number
  max: number
}
export const ScoringModalTotalPoints: FC<ScoringModalTotalPointsProps> = ({
  row,
  results,
  totalPoints,
  maxPoints,
  max,
}) => {
  return (
    <div className="my-4 flex gap-2">
      <div
        className={clsx(
          'py-2 px-3 flex justify-center items-center rounded-lg border border-[#D3DAEE] min-w-[56px]',
          getRankClasses({ rank: row.score?.rank, totalPoints: row.score?.totalPoints })
        )}
      >
        {Number(row?.score?.rank) && Number(row.score?.totalPoints) ? row.score?.rank : 'Rank'}
      </div>
      <div
        className={clsx(
          'px-4 py-2 flex items-center rounded-lg border-SeabiscuitLightThemeColorD3 w-full bg-SeabiscuitLightThemeColorD3/50'
        )}
      >
        {results?.sheet?.name ? (
          <>
            Total Points:
            <div className="ml-auto flex items-center gap-3">
              <p>
                <span className="font-bold">{totalPoints || 0}</span> / {maxPoints}
              </p>
              <p className="bg-white rounded-full p-2 min-w-[72px] text-center">
                {totalPoints > 0 ? toFixed((Number(totalPoints) / Number(max)) * 100, 3) : 0}%
              </p>
            </div>
          </>
        ) : (
          results?.totalPoints && (
            <>
              Score:
              <div className="ml-auto flex items-center gap-3">
                <p className="font-bold">{results?.totalPoints ?? 0}</p>
              </div>
            </>
          )
        )}
      </div>
    </div>
  )
}
